// extracted by mini-css-extract-plugin
export default {"container":"VerifyResult_container__tdcG-"};